
<div class="w-100 background-aliceblue" >
    <div class="w-100 pt-2" v-if="!separated" >
        <drop class="ml-4 mr-2 cut" @drop="onDrop" mode="cut" :accepts-data="onAcceptData">
            <c-card-iterator
                v-if           = "recipients"
                :label         = "title"
                :items         = "recipients"
                :filter-height = "180"
                :item-height   = "190"
                :height        = "800"
                :enable-search = "false"
                :zoom          = "false"
                :left-arrow    = "false"
                :show-filter   = "false"
                class          = "w-100"
                background="background-aliceblue"
            >
                <template v-slot:card="{ item }">
                    <c-recipient-card
                        style        = "width: calc(100% - 1px)"
                        :company     = "item.recipient"
                        :enable-edit = "false"
                    >
                        <template v-slot:toolbar>
                            <div style="margin-top: -4px;">
                                <c-toolbar-button
                                    icon    = "mdi-close"
                                    size    = "22"
                                    color   = "red"
                                    tooltip = "Entfernen"
                                    @click  = "onRemove(item)"
                                />
                            </div>
                        </template>
                    </c-recipient-card>
                </template>
            </c-card-iterator>
        </drop>
    </div>

    <div class="w-100 pt-2" v-if="separated">
        <c-column-header :label="title" class="primary mt-2 mr-2 ml-2 pb-0" />
        <c-site-recipients-separated
            title            = "Störungen usw."
            class            = "mt-3"
            :recipients      = "incidents"
            :accept-property = "acceptProperty"
            usage            = "INCIDENT"
            @assign          = "onAssign"
            @remove          = "onRemove"
        />

        <c-site-recipients-separated
            title            = "Wartungs-, Notruf- und ZÜS-Rechnungen"
            class            = "mt-6"
            :recipients      = "costs"
            :accept-property = "acceptProperty"
            usage            = "COSTS"
            @assign          = "onAssign"
            @remove          = "onRemove"
        />

        <c-site-recipients-separated
            title            = "Reparaturen"
            class            = "mt-6"
            :recipients      = "repairs"
            :accept-property = "acceptProperty"
            usage            = "REPAIR"
            @assign          = "onAssign"
            @remove          = "onRemove"
        />
    </div>
</div>
